import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

const LS_KEY = "observe.shell.lang";

export interface I18nApi {
  language: ReadOnlyStore<string>;
  setLanguage(lang: string): void;
}

export function createI18nApi(): I18nApi {
  const initial =
    (typeof localStorage !== "undefined" && localStorage.getItem(LS_KEY)) ||
    "en";
  const lang = createStore(initial);
  return {
    language: lang.store,
    setLanguage: (l) => {
      lang.set(l);
      try {
        localStorage.setItem(LS_KEY, l);
      } catch {
        /* ignore */
      }
    },
  };
}
